<template>
  <div>
    <demand-table :orderCode="orderCode" :disabled="disabled"/>
  </div>
</template>

<script>
import DemandTable from './components/demand-table/index'
export default {
  components: {
    DemandTable
  },
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {}
  }
}
</script>
